import { ClipType } from '@air/api/types';

import { type ItemTypeFilter } from '~/components/Filters/types';

export const assetClipTypes = Object.keys(ClipType).filter((type) => type !== ClipType.nonMedia);

export const assetFileType = ClipType.nonMedia;

export const getTypesToFetchFromParams = (typesParam: ItemTypeFilter[]) => {
  let types: ClipType[] = Object.keys(ClipType) as ClipType[];
  if (typesParam.length) {
    if (!typesParam.includes('files')) {
      types = types.filter((type) => type !== assetFileType);
    }
    if (!typesParam.includes('assets')) {
      types = types.filter((type) => !assetClipTypes.includes(type));
    }
  }
  return types;
};
